<template>
  <label
    class="def-email"
    :class="{
      'def-email_invalid': (!isValid || isError) && required,
      'def-email_success': isSuccess,
    }"
  >
    <span
      class="def-email__placeholder"
      :class="{ 'def-email__placeholder_center': !saveValue?.length && !isFocus }"
    >
      {{ label ?? placeholder }}
    </span>

    <input
      :id="id"
      ref="email"
      :type="type"
      :name="name"
      :required="required"
      :value="saveValue"
      :autocomplete="autocomplete"
      :form="form"
      class="def-email__input"
      pattern="^([a-z0-9_\-]+\.)*[a-z0-9_\-]+@[a-z0-9_\-]+(\.[a-z0-9_\-]+)*\.[a-z]{2,6}$"
      @input="handlerInput"
      @change="$emit('change', $event)"
      @click="$emit('click', $event)"
      @keypress="$emit('keypress', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @invalid.prevent="handlerInvalid"
      @blur="handlerBlur"
      @focus="handlerFocus"
    />
    <transition name="fade">
      <span v-if="!isValid" class="def-email__error">
        <slot />
      </span>
      <span v-else-if="isError" class="def-email__error">
        <slot name="error" />
      </span>

      <span v-else-if="isSuccess" class="email-success-text">
        <slot name="success" />
      </span>
    </transition>
  </label>
</template>

<script>
export default {
  name: 'DefEmail',
  props: {
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: Boolean,
    value: {
      type: String,
      default: '',
    },
    id: String,
    label: String,
    form: String,
    type: {
      type: String,
      default: 'email',
    },
    isError: Boolean,
    isSuccess: Boolean,
  },
  data() {
    return {
      isValid: true,
      isFocus: false,
      saveValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.saveValue = newValue;
    },
  },
  methods: {
    handlerInput(e) {
      this.saveValue = e.target.value;
      this.$emit('input', e);
    },
    handlerInvalid(e) {
      if (this.required) {
        this.isValid = false;
      }

      this.$emit('invalid', e);
    },
    handlerBlur(e) {
      const { target } = e;
      this.saveValue = target.value;
      if (target.checkValidity() && this.required) {
        this.isValid = true;
      }
      this.isFocus = false;
      this.$emit('blur', e);
    },
    handlerFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-email {
  display: inline-block;
  position: relative;
  height: 52px;
  padding: 8px 16px;
  border: 1px solid #c8c8c8;
  &__placeholder {
    position: absolute;
    top: 8px;
    color: var(--color-dark-grey);
    transition: 0.2s linear top;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100% - 32px);
    overflow: hidden;
    font-size: 14px;
    font-weight: 500;
    &_center {
      font-size: rem(16);
      top: 16px;
    }
  }
  &__input {
    font-weight: 500;
    font-size: rem(16);
    border: none;
    height: 42px;
    padding-top: 6px;
    transition: 0.2s linear border-bottom-color;
    padding-right: 20px;
    width: 100%;
    background-color: transparent;
  }
  &__error {
    position: absolute;
    left: 16px;
    top: calc(100% + 3px);
    font-size: rem(12);
    line-height: 100%;
    color: var(--color-red);
  }
  &_invalid {
    border-color: var(--background-red);
  }
  &_success {
    border-color: var(--color-green);
  }
}
.email-success-text {
  color: var(--color-green);
  font-size: rem(12);
}
</style>
